import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { ACTION_RELEASE_ASSIGNMENT_LOCK } from '../../store/state/actions';
import { processHeaders, SCOPE_TYPES } from '../../store/state/epics/util';
import { logAndCatchError } from '../../utils/rxjs-utils';
import type { Action } from '../../store/state/state-manager';
import type { ActionObject } from '../../globals';
import NavigationUtils from '../../utils/navigation-utils';

export const executeReleaseLockRequest = (payload: Action['payload']) => {
  const headers: ActionObject['headers'] = {};
  const { routeKey, isModalAction, caseID, context, RemoteSystemID } = payload;

  if (RemoteSystemID) {
    headers.RemoteSystemID = RemoteSystemID;
  }

  const apiRouteKey = routeKey || ACTION_RELEASE_ASSIGNMENT_LOCK;

  const { restApi, reqType } = resolveRestApi(apiRouteKey, {
    ID: caseID,
    caseID,
    viewType: SCOPE_TYPES.PAGE
  });

  const caseCache = NavigationUtils.getComponentCache(caseID);
  const debugInfo = caseCache && typeof caseCache === 'object' ? caseCache : {};

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers: {
          ...headers,
          ...debugInfo
        }
      },
      context,
      {
        includeRemoteSystemIdIfPresent: !!RemoteSystemID
      }
    )
  ).pipe(
    map((response) => {
      NavigationUtils.resetComponentCache(caseID);
      if (isModalAction) {
        return {
          actionInPayload: payload
        };
      }
      return {
        response: response.data,
        actionInPayload: payload,
        headers: processHeaders(response.headers)
      };
    }),
    logAndCatchError(': Error occurred during ajax call at release lock request : ', context)
  );
};

export default executeReleaseLockRequest;
